//新密码
<template>
  <div id="new_pwd" v-loading="loading" element-loading-text="验证中...">
    <div class="pwd_form" v-if="!goLogin">
      <ul>
        <li>请输入新密码</li>
        <li class="input_area">
          <label for="new_password">新密码：</label>
          <input type="password" id="new_password" v-model="new_pwd" @keyup.enter="saveChange()" />
        </li>
        <li class="input_area">
          <label for="sure_password">确认密码：</label>
          <input type="password" id="sure_password" v-model="sure_pwd" @keyup.enter="saveChange()" />
        </li>
        <li class="sign_in">
          <el-button
            type="primary"
            :disabled="new_pwd === '' && sure_pwd === ''"
            @click="saveChange()"
          >保存修改</el-button>
        </li>
      </ul>
    </div>
    <div class="jump" v-else>
      <p>{{times}}s后自动跳转登录页...</p>
      <router-link :to="{name: 'pcibOrderLogin'}">前往登录</router-link>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
export default {
  name: "pcib-order-new-pwd",
  props: {},
  watch: {},
  data() {
    return {
      new_pwd: "",
      sure_pwd: "",
      loading: false,
      goLogin: false,
      timer: null,
      times: 5
    };
  },
  methods: {
    saveChange() {
      let self = this;
      if (!self.new_pwd.trim() || !self.sure_pwd.trim()) {
        return false;
      }
      if (self.new_pwd !== self.sure_pwd) {
        self.$notify.info({
          message: "两次输入密码不一致",
          offset: 70
        });
        return false;
      }
      self.loading = true;
      post("user/password/reset/confirm/", {
        token: self.$route.query.token,
        uid: self.$route.query.uid,
        new_password1: self.new_pwd,
        new_password2: self.sure_pwd
      }).then(
        res => {
          self.loading = false;
          self.goLogin = true;
          self.$notify({
            type: "success",
            message: "密码修改成功",
            offset: 70
          });
          self.timer = setInterval(function() {
            self.times = self.times - 1;
            if (self.times === 0) {
              clearInterval(self.timer);
              self.$router.push({
                name: "pcibOrderLogin"
              });
            }
          }, 1000);
        },
        err => {
          self.loading = false;
          self.$notify.info({
            message: "链接已失效",
            offset: 70
          });
        }
      );
    }
  },
  beforeDestroy() {
    if (self.timer) {
      clearInterval(self.timer);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderNewPwd.vue